// --------------------- Import Globais ---------------------
import { useEffect, useState } from "react";
// --------------------- Import Antd-Design ---------------------
import { Modal } from "antd";
// --------------------- Import Hooks ---------------------
import { useAtualizarAnuncio } from "../hooks/useAtualizarAnuncio";
// --------------------- Import Styles ---------------------
import { Title } from "../../ViewGerenciarPostagens/styles";
// --------------------- Import Uteis ---------------------
import { useMessage } from "../../../uteis/mensagens/useMessage";
// --------------------- Import Interface ---------------------
import { ModalAnuncioProps } from "../interface/ModalAnuncio";

export default function ModalDesativar({
  isModalOpen,
  handleFechar,
  anuncioId,
  buscar,
}: ModalAnuncioProps) {
  // Seta o dado que irá ser atualizado
  const data = {
    active: 0,
  };
  // Chamada da função para atualizar
  const {
    atualizar,
    isLoading: isLoadingAtualizar,
    error,
    success,
    resetSuccess,
    resetError,
  } = useAtualizarAnuncio();

  // Mensagens
  const { showSuccess, showError, contextHolder } = useMessage();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  useEffect(() => {
    if (isModalOpen && success && !successDisplayed) {
      // Mensagem de sucesso
      const msgSuccess = "Anúncio desativado com sucesso!";
      showSuccess(msgSuccess);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        resetSuccess();
        handleFechar();
        buscar();
      }, 2000);
    }

    if (isModalOpen && error && !errorDisplayed) {
      // Mensagem de erro
      let msgError =
        "Não foi possível desativar este anúncio, por favor tente novamente!";
      showError(msgError);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }

    // Reset quando o modal fecha
    if (!isModalOpen) {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    resetSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    resetError,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Desativar"
        onOk={() => atualizar(anuncioId, data)}
        confirmLoading={isLoadingAtualizar}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {
          <>
            <>{contextHolder}</>
            <Title>Tem certeza que gostaria de desativar este Anúncio?</Title>
          </>
        }
      </Modal>
    </>
  );
}
